import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ReactFlowProvider } from "reactflow";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter } from "react-router-dom";
const mount = () => {
    const root = createRoot(document.getElementById("root"));
    root.render(_jsx(GoogleOAuthProvider, { clientId: process.env.VITE_GOOGLE_CLIENT_ID, children: _jsx(BrowserRouter, { children: _jsx(ReactFlowProvider, { children: _jsx(App, {}) }) }) }));
};
mount();
